var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartVaccineCard_1;
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { Card, Image, Text, TextFontSize } from '@philips-internal/oswald-ui-components/lib/components';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import MyChartVaccineCardAPI from './my-chart-vaccine-card-api';
import CalendarSVG from '../../assets/images/icons/calendar.svg';
import ConfirmedSVG from '../../assets/images/icons/Confirmed.svg';
import './my-chart-vaccine-card.css';
import DateFormatterUtil from '../../util/date-utils/date-formatter-util';
let MyChartVaccineCard = MyChartVaccineCard_1 = class MyChartVaccineCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClickVaccine = () => {
            const { onClick, read, sequence, vaccineName, applicationDate } = this.props;
            const textSituationType = applicationDate == null
                ? MessageService.translate('patient.vaccine-preview')
                : MessageService.translate('patient.vaccine-applied');
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        read,
                        sequence,
                        textSituationType,
                        vaccineName
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        className: string,
        onClick: eventListener,
        uuid: string,
    }; }
    static { this.defaultProps = {
        width: 12,
    }; }
    render() {
        const { uuid, className, width = MyChartVaccineCard_1.defaultProps.width, vaccineName, applicationDate, estimatedDate, read } = this.props;
        const estimedDateFormat = estimatedDate ? DateFormatterUtil.date(estimatedDate) : '-';
        const applicationDateFormat = applicationDate ? DateFormatterUtil.date(applicationDate) : '-';
        let textSituationType = MessageService.translate('patient.vaccine-applied');
        let iconStatus = ConfirmedSVG;
        if (applicationDate == null) {
            iconStatus = CalendarSVG;
            textSituationType = MessageService.translate('patient.vaccine-preview');
        }
        const notViewedClass = read === 'N' ? 'not-viewed' : '';
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.SINGLE, width: width, className: `${className} ${notViewedClass}`, onClick: () => this.handleClickVaccine() },
            React.createElement("div", { className: 'vaccine' },
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "info-content" },
                        React.createElement("span", { className: "label-info" },
                            React.createElement(Text, { className: "subtitle", value: `${MessageService.translate('patient.label.vaccine')}` })),
                        React.createElement("span", { className: "emphasis-info subtitle" },
                            React.createElement(Text, { bold: true, size: TextFontSize.SMALL, className: "subtitle", value: vaccineName })))),
                React.createElement("div", { className: "detail-area detail-status" },
                    React.createElement("div", { className: "info-content info-content-status-label" },
                        React.createElement("span", { className: "label-info" },
                            React.createElement(Text, { className: "subtitle", value: `${MessageService.translate('patient.status-title')}` }))),
                    React.createElement("div", { className: "info-content-status" },
                        React.createElement("div", { className: 'status-icon' },
                            React.createElement(Image, { src: iconStatus, alt: '' })),
                        React.createElement("div", { className: "content-text-status" },
                            React.createElement(Text, { bold: true, size: TextFontSize.SMALL, className: "subtitle", value: textSituationType })))),
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "info-content" },
                        React.createElement("span", { className: "label-info" },
                            React.createElement(Text, { className: "subtitle", value: `${MessageService.translate('patient.label.estimed-date')}` })),
                        React.createElement("span", { className: "emphasis-info" },
                            React.createElement(Text, { bold: true, size: TextFontSize.SMALL, className: "subtitle", value: estimedDateFormat })))),
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "info-content" },
                        React.createElement("span", { className: "label-info" },
                            React.createElement(Text, { className: "subtitle", value: `${MessageService.translate('patient.label.application-date')}` })),
                        React.createElement("span", { className: "emphasis-info" },
                            React.createElement(Text, { bold: true, size: TextFontSize.SMALL, className: "subtitle", value: applicationDateFormat })))))));
    }
};
MyChartVaccineCard = MyChartVaccineCard_1 = __decorate([
    AwesomeComponent({ api: MyChartVaccineCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartVaccineCard);
export default MyChartVaccineCard;
//# sourceMappingURL=my-chart-vaccine-card.js.map